import { render, staticRenderFns } from "./quotaAccountLog.vue?vue&type=template&id=fece6942&scoped=true"
import script from "./quotaAccountLog.vue?vue&type=script&lang=js"
export * from "./quotaAccountLog.vue?vue&type=script&lang=js"
import style0 from "./quotaAccountLog.vue?vue&type=style&index=0&id=fece6942&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fece6942",
  null
  
)

export default component.exports